import moment from "moment-timezone";
import { TIME_RANGE_TYPE } from "../../../contexts/CalendarTimeContext";

/** time formats for control label */
const TIME_FORMATS = Object.freeze({
  month: "MMM|YYYY",
  threeDays: "MMM D|YYYY",
  week: "MMM D|YYYY",
  day: "MMM D|YYYY",
} as const);

/**
 * get the time range text that renders in the calendar header
 */
export function getTimeRangeText({
  anchorTime,
  timeRange,
  type,
  timezone,
}: {
  anchorTime: number;
  timeRange: number[];
  type: TIME_RANGE_TYPE;
  timezone: TimeZone;
}): {
  date: string;
  year: string;
}[] {
  switch (type) {
    case "month": {
      const [date, year] = moment(anchorTime)
        .tz(timezone)
        .format(TIME_FORMATS[type])
        .split("|");
      return [
        {
          date,
          year,
        },
      ];
    }

    case "threeDays":
    case "week": {
      const [startString, endString] = timeRange.map((el) =>
        moment(el).tz(timezone).format(TIME_FORMATS[type]),
      );
      const [startDate, startYear] = startString.split("|");
      const [endDate, endYear] = endString.split("|");

      const isSameYear = startYear === endYear;
      return [
        {
          date: startDate,
          year: isSameYear ? "" : startYear,
        },
        {
          date: endDate,
          year: endYear,
        },
      ];
    }

    case "day": {
      const [startString] = timeRange.map((el) =>
        moment(el).tz(timezone).format(TIME_FORMATS[type]),
      );
      const [startDate, startYear] = startString.split("|");
      return [
        {
          date: startDate,
          year: startYear,
        },
      ];
    }

    default:
      return [];
  }
}
